
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
//   selectedNoteType: "",
  loading: false,
  addsettingInvoiceLoading: false,
settingInvoice:null,
stripeaccounts:null,

};

export const invoiceSettingState = createSlice({
  name: "invoicesettingReducer",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload
      };
    },

    setAddInvoiceSettingLoading(state, action) {
      return {
        ...state,
        addsettingInvoiceLoading: action?.payload
      };
    },



    setAllInvoicesSetting(state, action) {
        return {
          ...state,
          loading: false,
          settingInvoice: action?.payload,
        };
      },

      setAllStripeAccounts(state, action) {
        return {
          ...state,
          loading: false,
          stripeaccounts: action?.payload,
        };
      },

      




    // Reset State
    reset() {
      return initialState;
    }
  }
});

export const {
  setLoading,
  setAddInvoiceSettingLoading,
  setAllInvoicesSetting,
  setAllStripeAccounts,
 
} = invoiceSettingState.actions;
export default invoiceSettingState.reducer;
